import { render, staticRenderFns } from "./LSReport.vue?vue&type=template&id=5e546194"
import script from "./LSReport.vue?vue&type=script&lang=ts&setup=true"
export * from "./LSReport.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/PortfolioWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e546194')) {
      api.createRecord('5e546194', component.options)
    } else {
      api.reload('5e546194', component.options)
    }
    module.hot.accept("./LSReport.vue?vue&type=template&id=5e546194", function () {
      api.rerender('5e546194', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ClientScripts/Components/LSReport/LSReport.vue"
export default component.exports